module.exports = __webpack_public_path__ + "static/img/search_risk_logo.b621f8a3.png";